// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_j2-0";
export var actionModalContentContainer = "_j2-1";
export var createTagButton = "_j2-2";
export var footerContainer = "_j2-7";
export var fullWidthDivider = "_j2-3";
export var hasCreateTagButton = "_j2-4";
export var noCreateTagButton = "_j2-5";
export var tagsContainer = "_j2-6";
export var tagsModalContentContainer = "_j2-8";